import {useDialog} from '@hooks';

export const useConfirmationDialog = () => {
  const {confirmationDialog} = useDialog();

  return {confirmationDialog};
};
